/*
 * @Author: chengyunxiao
 * @Date: 2023-05-18 10:58:01
 * @LastEditTime: 2024-03-28 10:49:02
 * @Description: Do not eidt
 */
import axios from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { getUrlByPromise } from '@/utils/tools';
import { convertObjectKeysToCamelCase } from '@king-fisher/khxtzsq-business';

type Result<T> = {
  statusCode?: number;
  statusMsg?: string;
  code?: number;
  msg?: string;
  data: T;
};

// 导出Request类，可以用来自定义传递配置来创建实例
export class Request {
  // axios 实例
  instance: AxiosInstance;
  // 基础配置，url和超时时间
  baseConfig: AxiosRequestConfig = {
    baseURL: '/',
    timeout: 6000,
    withCredentials: true
  };
  constructor(config: AxiosRequestConfig) {
    // 使用axios.create创建axios实例
    this.instance = axios.create(Object.assign(this.baseConfig, config));

    this.instance.interceptors.request.use(
      async (reqconfig: InternalAxiosRequestConfig) => {
        // 备用域名处理
        reqconfig.url = await getUrlByPromise(reqconfig.url || '');
        return reqconfig;
      },
      // 请求错误，这里可以用全局提示框进行提示
      (err: any) => Promise.reject(err)
    );

    this.instance.interceptors.response.use(
      // 直接返回res，当然你也可以只返回res.data 系统如果有自定义code也可以在这里处理
      (res: AxiosResponse) => {
        return convertObjectKeysToCamelCase(res.data) as AxiosResponse;
      },
      // 请求错误，这里可以用全局提示框进行提示
      (err: any) => err
    );
  }

  // 定义请求方法
  public request(config: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.instance.request(config);
  }

  public get<T = any>(url: string, config?: AxiosRequestConfig): Promise<Result<T>> {
    return this.instance.get(url, config);
  }
  public post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<Result<T>> {
    return this.instance.post(url, data, config);
  }

  public put<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<Result<T>> {
    return this.instance.put(url, data, config);
  }

  public delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<Result<T>> {
    return this.instance.delete(url, config);
  }
  /**
   * jsonp请求封装
   * @param url 请求地址
   * @param data 请求数据
   */
  public async jsonp<T = any>(url: string, data: any): Promise<Result<T>> {
    // 备用域名的处理
    const domainUrl = await getUrlByPromise(url);
    return new Promise((resolve, reject) => {
      window.$.ajax({
        data,
        type: 'get',
        url: domainUrl,
        async: false,
        dataType: 'jsonp',
        timeout: 3000,
        success: function success(res: any) {
          resolve(res);
        },
        error: function error(err: any) {
          reject(err);
        }
      });
    });
  }
}

// 默认导出Request实例
export default new Request({});
